/**
 * Updates the currency display, country name, and flag images in the header,
 * mobile nav, and intl menu for all markets.
 *
 * Uses Shopify's localization.available_countries (rendered as JSON in site-header.liquid)
 * and Intl.DisplayNames to match localized country names (e.g. "España" → Spain → EUR).
 */
document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('intl-currency-data');
  if (!dataEl) return;

  var countries;
  try {
    countries = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!countries.length) return;

  // Build name → currency map
  var currencyByName = {};
  var langs = ['en', 'es', 'de', 'fr', 'it', 'pt', 'nl', 'da', 'sv', 'nb', 'ja', 'ko', 'zh'];

  countries.forEach(function (c) {
    var entry = { code: c.currency, symbol: c.symbol, name: c.name };

    // Map by Shopify's English name
    currencyByName[c.name.toLowerCase()] = entry;

    // Map by 2-letter ISO code (for direct lookups)
    currencyByName[c.iso.toLowerCase()] = entry;

    // Generate alternative names in multiple languages via Intl.DisplayNames
    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      langs.forEach(function (lang) {
        try {
          var name = new Intl.DisplayNames([lang], { type: 'region' }).of(c.iso);
          if (name) currencyByName[name.toLowerCase()] = entry;
        } catch (e) {}
      });
    }
  });

  function getCurrencyForCountry(countryName) {
    if (!countryName) return null;
    return currencyByName[countryName.toLowerCase()] || null;
  }

  // Countries allowed to show their local currency (URL country codes for managed markets)
  var ALLOWED_COUNTRY_CODES = ['ca', 'au', 'gb', 'sg', 'ch', 'de', 'in'];
  // Country names for en-int localStorage matching (includes US as the default fallback)
  var ALLOWED_COUNTRY_NAMES = ['united states', 'canada', 'australia', 'united kingdom', 'england', 'singapore', 'switzerland', 'germany', 'india'];

  function updateCountryName(name) {
    document.querySelectorAll('.js-intl-name').forEach(function (el) {
      el.textContent = name;
    });
  }

  function updateCurrencyDisplay(code, symbol) {
    document.querySelectorAll('.js-intl-currency').forEach(function (el) {
      el.textContent = code + ' (' + symbol + ')';
    });
    document.querySelectorAll('.js-intl-currency-group').forEach(function (el) {
      el.style.display = '';
    });
  }

  function storeCurrency(code, symbol) {
    localStorage.setItem('teddy-intl-currency', code);
    localStorage.setItem('teddy-intl-symbol', symbol);
  }

  // Load flag images (convert Liquid-rendered data-src to src)
  function loadFlags() {
    document.querySelectorAll('.js-intl-flag').forEach(function (img) {
      var dataSrc = img.dataset.src || img.getAttribute('data-src');
      if (dataSrc && !img.src.includes(dataSrc)) {
        img.src = dataSrc;
      }
    });
  }

  // On country link click: look up and store currency (default to USD if not in allowed list)
  document.querySelectorAll('.intl-menu__link').forEach(function (link) {
    link.addEventListener('click', function () {
      var countryName = link.dataset.country;
      var isAllowed = countryName && ALLOWED_COUNTRY_NAMES.indexOf(countryName.toLowerCase()) !== -1;
      if (isAllowed) {
        var match = getCurrencyForCountry(countryName);
        if (match) {
          storeCurrency(match.code, match.symbol);
        }
      } else {
        storeCurrency('USD', '$');
      }
      // Store flag URL for en-int restoration
      var flagImg = link.querySelector('.intl-menu__flag img');
      if (flagImg && flagImg.src) {
        localStorage.setItem('teddy-intl-flag', flagImg.src);
      }
    });
  });

  // On page load: update currency display for the current market
  var pathMatch = window.location.pathname.match(/^\/en-([a-z]{2,3})(?:\/|$)/);
  var storePrefix = pathMatch ? 'en-' + pathMatch[1] : null;
  var isEnInt = storePrefix === 'en-int';

  // Load flag images for all markets
  loadFlags();

  if (isEnInt) {
    // International market: update name, currency, and flag from localStorage
    var countryName = localStorage.getItem('teddy-intl');

    // Always update country name for en-int if available
    if (countryName) {
      updateCountryName(countryName);
    }

    // Restore flag from localStorage
    var storedFlag = localStorage.getItem('teddy-intl-flag');
    if (storedFlag) {
      document.querySelectorAll('.js-intl-flag').forEach(function (img) {
        img.src = storedFlag;
      });
    }

    var isAllowed = countryName && ALLOWED_COUNTRY_NAMES.indexOf(countryName.toLowerCase()) !== -1;

    if (isAllowed) {
      var storedCode = localStorage.getItem('teddy-intl-currency');
      var storedSymbol = localStorage.getItem('teddy-intl-symbol');

      if (storedCode && storedSymbol) {
        updateCurrencyDisplay(storedCode, storedSymbol);
      } else {
        var match = getCurrencyForCountry(countryName);
        if (match) {
          storeCurrency(match.code, match.symbol);
          updateCurrencyDisplay(match.code, match.symbol);
        }
      }
    } else if (countryName) {
      // Country is set but not in the allowed list — default to USD
      storeCurrency('USD', '$');
      updateCurrencyDisplay('USD', '$');
    }
  } else if (storePrefix) {
    // Managed markets (en-de, en-gb, etc.): check country code against allowed list
    var countryCode = pathMatch[1];
    var match = getCurrencyForCountry(countryCode);
    if (ALLOWED_COUNTRY_CODES.indexOf(countryCode) !== -1 && match) {
      updateCurrencyDisplay(match.code, match.symbol);
    } else {
      // Unsupported managed market — default to USD
      updateCurrencyDisplay('USD', '$');
    }
  }
});
